import { SLOT_KIND_OPTIONS } from "../shared";

/**
 * Inline "Add slot" form. Renders inside CalendarPanel beneath the toolbar
 * when adding=true. Parent owns the form state so it can be primed from
 * DayEventsDrawer's "Add slot to this day" CTA.
 */
const AddSlotForm = ({ newSlot, setNewSlot, onSubmit, onCancel }) => (
  <form
    onSubmit={onSubmit}
    data-testid="cal-add-slot-form"
    className="mt-4 border border-[var(--ld-border)] bg-[var(--ld-ivory-warm)]/30 p-4 flex flex-wrap items-end gap-3"
  >
    <label className="flex flex-col gap-1">
      <span className="text-[10px] tracking-[0.2em] uppercase text-[var(--ld-ink-muted)]">
        Date
      </span>
      <input
        type="date"
        required
        data-testid="cal-add-date"
        value={newSlot.date}
        onChange={(e) => setNewSlot((s) => ({ ...s, date: e.target.value }))}
        className="h-9 px-2 text-[12px] bg-white/70 border border-[var(--ld-ink)]/25"
      />
    </label>
    <label className="flex flex-col gap-1">
      <span className="text-[10px] tracking-[0.2em] uppercase text-[var(--ld-ink-muted)]">
        Time
      </span>
      <input
        type="time"
        required
        data-testid="cal-add-time"
        value={newSlot.time}
        onChange={(e) => setNewSlot((s) => ({ ...s, time: e.target.value }))}
        className="h-9 px-2 text-[12px] bg-white/70 border border-[var(--ld-ink)]/25"
      />
    </label>
    <label className="flex flex-col gap-1">
      <span className="text-[10px] tracking-[0.2em] uppercase text-[var(--ld-ink-muted)]">
        Kind / colour
      </span>
      <select
        data-testid="cal-add-kind"
        value={newSlot.kind}
        onChange={(e) => setNewSlot((s) => ({ ...s, kind: e.target.value }))}
        className="h-9 px-2 text-[12px] bg-white/70 border border-[var(--ld-ink)]/25"
      >
        {SLOT_KIND_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
    <label className="flex flex-col gap-1">
      <span className="text-[10px] tracking-[0.2em] uppercase text-[var(--ld-ink-muted)]">
        Duration
      </span>
      <select
        data-testid="cal-add-duration"
        value={newSlot.duration_minutes}
        onChange={(e) =>
          setNewSlot((s) => ({ ...s, duration_minutes: Number(e.target.value) }))
        }
        className="h-9 px-2 text-[12px] bg-white/70 border border-[var(--ld-ink)]/25"
      >
        {[15, 30, 45, 60, 90, 120].map((m) => (
          <option key={m} value={m}>
            {m} min{m === 30 ? " · default" : ""}
          </option>
        ))}
      </select>
    </label>
    {/* Label input — required for admin_held; optional for other kinds */}
    <label className="flex flex-col gap-1 flex-1 min-w-[200px]">
      <span className="text-[10px] tracking-[0.2em] uppercase text-[var(--ld-ink-muted)]">
        {newSlot.kind === "admin_held" ? "Slot is for *" : "Label (optional)"}
      </span>
      <input
        type="text"
        data-testid="cal-add-label"
        value={newSlot.label}
        onChange={(e) => setNewSlot((s) => ({ ...s, label: e.target.value }))}
        placeholder={
          newSlot.kind === "admin_held"
            ? "e.g. Consultation with Anjali & Rohan"
            : "Optional internal note"
        }
        maxLength={120}
        className="h-9 px-2 text-[12px] bg-white/70 border border-[var(--ld-ink)]/25"
      />
    </label>
    <button
      type="submit"
      data-testid="cal-add-submit"
      className="h-9 px-4 text-[10px] tracking-[0.2em] uppercase bg-[var(--ld-ink)] text-[var(--ld-gold)] border border-[var(--ld-ink)] hover:bg-black"
    >
      Add slot
    </button>
    <button
      type="button"
      onClick={onCancel}
      className="h-9 px-3 text-[10px] tracking-[0.2em] uppercase border border-[var(--ld-ink)]/30 text-[var(--ld-ink)] hover:bg-[var(--ld-ink)] hover:text-[var(--ld-gold)]"
    >
      Cancel
    </button>
  </form>
);

export default AddSlotForm;
